import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { reviewDesk } from '@/design-system';
import { COLORS, profileWebStyles } from '../profileStyles';

interface ProfileActionRowProps {
  title: string;
  subtitle: string;
  icon: keyof typeof MaterialIcons.glyphMap;
  onPress: () => void;
  dangerous?: boolean;
  testID?: string;
}

/** A tappable settings row: icon, title/subtitle and a chevron. */
export function ProfileActionRow({ title, subtitle, icon, onPress, dangerous = false, testID }: ProfileActionRowProps) {
  return (
    <TouchableOpacity
      style={[profileWebStyles.actionRow, dangerous && profileWebStyles.actionRowDanger]}
      onPress={onPress}
      accessibilityRole="button"
      testID={testID}
    >
      <View style={[profileWebStyles.actionIcon, dangerous && profileWebStyles.actionIconDanger]}>
        <MaterialIcons name={icon} size={21} color={dangerous ? COLORS.error : reviewDesk.accent} />
      </View>
      <View style={profileWebStyles.actionText}>
        <Text style={[profileWebStyles.actionTitle, dangerous && profileWebStyles.actionTitleDanger]}>{title}</Text>
        <Text style={profileWebStyles.actionSubtitle}>{subtitle}</Text>
      </View>
      <MaterialIcons name="chevron-right" size={20} color={dangerous ? COLORS.error : reviewDesk.inkSoft} />
    </TouchableOpacity>
  );
}
